import React from "react";
import styles from "./Password.module.scss";
import {
  Controller,
  type Control,
  type UseFormRegister,
} from "react-hook-form";
import withLabelAndError from "../withLabelAndError";
import Eye from "@/components/SVGComponents/Eye";
import EyeSlash from "@/components/SVGComponents/EyeSlash";

interface PasswordProps {
  control?: Control<any>;
  register?: UseFormRegister<any>;
  validations?: Record<string, any>;
  name: string;
  placeholder?: string;
  label?: string;
  [key: string]: any;
}

const Password = (props: any) => {
  const { control, register, validations, name, placeholder, ...rest } = props;

  const [showPassword, setShowPassword] = React.useState(false);
  const [inputValue, setInputValue] = React.useState("");
  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const renderInput = (field : any) => {
    const hasValue = inputValue.length > 0;
    return (
      <div className={styles.passwordWrapper}>
        <input
          {...field}
          {...rest}
          id={name}
          type={showPassword ? "text" : "password"}
          className={styles.inputField}
          placeholder={placeholder}
          onChange={(e) => {
          field?.onChange?.(e);   
          setInputValue(e.target.value);
        }}
        />
        {hasValue && (
          showPassword ? (
            <Eye onClick={toggleShowPassword} className={styles.eyeIcon} />
          ) : (
            <EyeSlash onClick={toggleShowPassword} className={styles.eyeIcon} />
          )
        )}
      </div>
    );
  };

  if (control) {
    return (
      <Controller
        control={control}
        rules={validations}
        name={name}
        render={({ field }) => renderInput(field)}
      />
    );
  } else {
    const field = register && register(name, validations);
    return renderInput(field);
  }
};

const PasswordWithLabelAndError = withLabelAndError(Password);

export default PasswordWithLabelAndError;
export { Password };
